import { constants, mediaQueryStyles } from "@newsela/angelou";
const {
  breakpoints: { BreakpointNames },
} = constants;
const { md, sm } = BreakpointNames;
const { mediaQuery } = mediaQueryStyles;

export const bannerHeaderTextCss = {
  textAlign: "center",
  [mediaQuery.downTo(md)]: {
    margin: "0px 55px 0 10px",
  },
  [mediaQuery.upTo(sm)]: {
    margin: "0px 10px",
  },
};
